import { GeneralCommonsModule } from '@/src/app/shared/modules/general-commons/general-commons.module';
import { CommonModule, AsyncPipe } from '@angular/common';
import { Component, NgModule, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ReportConfig } from '../../components/report-filters/models/report-filters.model';
import { ReportFiltersModule, ReportFiltersComponent } from '../../components/report-filters/report-filters.component';
import { ReportTableDataService } from '../../components/report-filters/services/report-table-data.service';
import { ReportService } from '../../components/report-filters/services/report.service';
import { ReportHeaderComponent } from '../../components/report-header/report-header.component';
import { PhotoReportTableComponentModule, PhotoReportTableComponent } from './components/photo-report-table/photo-report-table.component';
import { PaginationSortingModel } from '@shared/components/table/models/pagination-sorting.model';
import { GenericWidePageComponent } from '@shared/modules/general-commons/components/generic-page-wide/generic-wide-page.component';

@Component({
  selector: 'stx-photo-report',
  templateUrl: './photo-report.component.html',
  imports: [GenericWidePageComponent, ReportHeaderComponent, ReportFiltersComponent, PhotoReportTableComponent, AsyncPipe, TranslateModule]
})
export class PhotoReportComponent {
  reportService = inject(ReportService);
  private reportTableDataService = inject(ReportTableDataService);

  reportConfig: ReportConfig = {
    type: 'PHOTO_REPORT',
    downloadOptions: {},
    filters: {
      age: true,
      gender: true,
      geography: true,
      organizationsTree: true,
      photoTypes: true,
      recordDate: true,
      // rejectedRecords: true, TODO#8912
      surgicalIntervention: true
    }
  };

  applyFilters(pagination: PaginationSortingModel) {
    this.reportTableDataService.prepareList(this.reportConfig.type, this.reportService.model, pagination);
  }
}

@NgModule({
  imports: [
    CommonModule,
    PhotoReportTableComponentModule,
    ReportFiltersModule,
    TranslateModule,
    GeneralCommonsModule,
    PhotoReportComponent
  ],
  exports: [PhotoReportComponent]
})
export class PhotoReportComponentModule {}
